import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    loading: false,
    docPreview: {},
    docSlider: {},
    visiblePreviewModal: false,
    visiblePreviewSliderModal: false,
    // validate_question: {},
    listComment: [],
    commentDetail: {},
    paramsSearchComments: {
        trainingId: 0,
        keyword: '',
        pageIndex: 1,
        pageSize: 5,
        sort: '',
        direction: ''
    },
    paramsSearchCommentDetail: {
        commentId: 0,
        keyword: '',
        pageIndex: 1,
        pageSize: 10,
        sort: '',
        direction: ''
    },
    pagingComment: {},
    payloadCreateComment: {
        trainingId: 0,
        comment: '',
        imageUrl: ''
    },
    draw_shape_data: {},
    toggle_draw: false,
    actionCheckQuestion: false,
    isShowGuideActiveBook: false,
    idActiveBookSuccessheader: 0,
    isShowModalActiveBookPage: false,
    isShowActiveBook: false,
    bookActiveWant: {},
    idBookActiveSuccess: null,
    isShowModalShare: false,
    mediaShareInfo: {},
    shareFacebook: 1,
    shareMail: 2,
    shareZalo: 3,
    shareCopy: 4,
    shareType: [
        { id: 1, name: 'Facebook', icon: 'icon-facebook' },
        { id: 2, name: 'Gmail', icon: 'icon-email' },
        // {id: 3, name: 'Zalo', icon: 'icon-zalo'},
        { id: 4, name: 'Copy link', icon: 'icon-link' }
    ],
    getCountNotifiNotRed: {},
    getDataDetailNotifi: {},
    getPramDisplay: false,

    isShowModalError: {},
    isShowModalHelp: false,
    isShowModalNotify: false,

    setListHelp:{},
    setIdDetailHelp: '',
    getHelpDetail: {},
    getHelpVideo:{},
    setRouterHelp: {},
	versionApp: '(Phiên bản 1.0)',
    getShowVideoHelp: {},
    setBookIdForError: 0,
    setBookIndexId:0,
    setPageNoBook:0,
    setBookPageLinkId:0,
    setQuestionId: 0,
    setInfoLibrary: {},
    setCountView: 0,
    setCheckExcercise: 0,
    setCheckSlideActiveBook: {},
    imgSlide:[],
    getDataModalNoti: {},
    getInfoExcercise: 0

    // [
    //     {id: 1, src: require('@/assets/img/HDKH1.png')},
    //     {id: 2, src: require('@/assets/img/HDKH2.png')},
    //     {id: 3, src: require('@/assets/img/HDKH3.png')}
    // ],
};

export default {
    namespaced: true,
    state,
    status,
    actions,
    getters,
    mutations,
};